const translations = {
  "en": {
    "Current Price": "Current Price"
  },
  "zh-tw": {
    "Current Price": "現價"
  }
};

export default translations;
